import { BadgeLogo } from './badge-svg';

const SVG_TAGS = new Set(['svg', 'g', 'path', 'circle', 'ellipse', 'rect', 'polygon', 'polyline', 'line']);
const SVG_ATTRS = new Set([
  'd',
  'cx',
  'cy',
  'r',
  'rx',
  'ry',
  'x',
  'y',
  'width',
  'height',
  'points',
  'x1',
  'y1',
  'x2',
  'y2',
  'transform',
  'fill',
  'stroke',
  'stroke-width',
  'fill-rule',
  'clip-rule',
  'opacity',
  'fill-opacity',
  'stroke-opacity',
  'stroke-linecap',
  'stroke-linejoin',
]);

export const MAX_BADGE_LOGO_BYTES = 100 * 1024;

const contentBox = (vb: string, inner: string) => {
  const probe = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  probe.setAttribute('viewBox', vb);
  probe.style.cssText = 'position:absolute;left:-9999px;width:100px;height:100px;visibility:hidden';
  probe.innerHTML = `<g>${inner}</g>`;
  document.body.appendChild(probe);
  try {
    const b = (probe.firstChild as SVGGraphicsElement).getBBox();
    return b.width && b.height ? `${b.x} ${b.y} ${b.width} ${b.height}` : vb;
  } catch (err) {
    return vb;
  } finally {
    probe.remove();
  }
};

const walk = (el: Element): string =>
  Array.from(el.children)
    .map((child) => {
      if (!SVG_TAGS.has(child.localName)) return '';
      const attrs: Record<string, string> = {};
      (child.getAttribute('style') || '').split(';').forEach((decl) => {
        const [k, v] = decl.split(':').map((x) => x && x.trim());
        if (k && v && SVG_ATTRS.has(k)) attrs[k] = v;
      });
      Array.from(child.attributes).forEach((a) => {
        if (SVG_ATTRS.has(a.name)) attrs[a.name] = a.value;
      });
      const safe = Object.keys(attrs)
        .filter((k) => !/url\(|javascript:|[<>"&]/i.test(attrs[k]))
        .map((k) => `${k}="${attrs[k]}"`)
        .join(' ');
      const tag = child.localName === 'svg' ? 'g' : child.localName;
      return `<${tag} ${safe}>${walk(child)}</${tag}>`;
    })
    .join('');

export const sanitizeBadgeSvg = (text: string, measure = true): BadgeLogo | null => {
  const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
  const root = doc.documentElement;
  if (doc.querySelector('parsererror') || root.localName !== 'svg') return null;
  const vb =
    root.getAttribute('viewBox') ||
    `0 0 ${parseFloat(root.getAttribute('width') || '') || 24} ${parseFloat(root.getAttribute('height') || '') || 24}`;
  if (!/^[\d.\s,-]+$/.test(vb)) return null;
  const inner = walk(root);
  if (!inner) return null;
  return { kind: 'svg', vb: measure ? contentBox(vb, inner) : vb, inner };
};
